{
  "HELP_CENTER": {
    "TITLE": "Asistenta",
    "NEW_PAGE": {
      "DESCRIPTION": "Creați portaluri de asistență cu autoservire pentru clienții dvs. Ajutați-i să găsească răspunsuri rapid, fără să aștepte. Simplificați solicitările, creșteți eficiența agenților și îmbunătățiți asistența pentru clienți.",
      "CREATE_PORTAL_BUTTON": "Creează Portal"
    },
    "NEW_ARTICLE_PAGE": {
      "PLACEHOLDER_TITLE": "Fără titlu"
    },
    "HEADER": {
      "FILTER": "Filtrați după",
      "SORT": "Sortați după",
      "LOCALE": "Limbă",
      "SETTINGS_BUTTON": "Setări",
      "NEW_BUTTON": "Articol nou",
      "DROPDOWN_OPTIONS": {
        "PUBLISHED": "Publicat",
        "DRAFT": "Draft",
        "ARCHIVED": "Arhivat"
      },
      "TITLES": {
        "ALL_ARTICLES": "Toate articolele",
        "MINE": "Articolele mele",
        "DRAFT": "Articole Draft",
        "ARCHIVED": "Articole arhivate"
      },
      "LOCALE_SELECT": {
        "TITLE": "Selectați limba",
        "PLACEHOLDER": "Selectați limba",
        "NO_RESULT": "Nicio limbă găsită",
        "SEARCH_PLACEHOLDER": "Căutare limbă"
      }
    },
    "EDIT_HEADER": {
      "ALL_ARTICLES": "Toate articolele",
      "PUBLISH_BUTTON": "Publicați",
      "MOVE_TO_ARCHIVE_BUTTON": "Mutați în arhivă",
      "PREVIEW": "Previzualizați",
      "ADD_TRANSLATION": "Adăugați traducere",
      "OPEN_SIDEBAR": "Deschideți bara laterală",
      "CLOSE_SIDEBAR": "Închideți bara laterală",
      "SAVING": "Se salvează...",
      "SAVED": "Salvat"
    },
    "ARTICLE_EDITOR": {
      "IMAGE_UPLOAD": {
        "TITLE": "Încarcă imaginea",
        "UPLOADING": "Încărcare...",
        "SUCCESS": "Imagine încărcată cu succes",
        "ERROR": "Eroare la încărcarea imaginii",
        "UN_AUTHORIZED_ERROR": "Nu sunteți autorizat să încărcați imagini",
        "ERROR_FILE_SIZE": "Dimensiunea imaginii trebuie să fie mai mică de {size}MB",
        "ERROR_FILE_FORMAT": "Formatul imaginii ar trebui să fie jpg, jpeg sau png",
        "ERROR_FILE_DIMENSIONS": "Dimensiunile imaginii ar trebui să fie mai mici de 2000 x 2000"
      },
      "ANCHOR": {
        "BUTTON": "Inserează ancoră",
        "TITLE": "Inserează ancoră",
        "SUBMIT": "Inserează",
        "PLACEHOLDER": "anchor-name"
      }
    },
    "ARTICLE_SETTINGS": {
      "TITLE": "Setări articol",
      "FORM": {
        "CATEGORY": {
          "LABEL": "Categorie",
          "TITLE": "Selectați categoria",
          "PLACEHOLDER": "Selectați categoria",
          "NO_RESULT": "Nicio categorie găsită",
          "SEARCH_PLACEHOLDER": "Căutare categorie"
        },
        "AUTHOR": {
          "LABEL": "Autor",
          "TITLE": "Selectați autorul",
          "PLACEHOLDER": "Selectați autorul",
          "NO_RESULT": "Nu s-au găsit autori",
          "SEARCH_PLACEHOLDER": "Căutare autor"
        },
        "META_TITLE": {
          "LABEL": "Titlu meta",
          "PLACEHOLDER": "Adaugați un titlu meta"
        },
        "META_DESCRIPTION": {
          "LABEL": "Descriere meta",
          "PLACEHOLDER": "Adăugați descrierea meta pentru rezultate SEO mai bune..."
        },
        "META_TAGS": {
          "LABEL": "Etichete meta",
          "PLACEHOLDER": "Adăugați etichete meta separate prin virgulă..."
        }
      },
      "BUTTONS": {
        "ARCHIVE": "Arhivați articolul",
        "DELETE": "Ștergeți articolul"
      }
    },
    "ARTICLE_SEARCH_RESULT": {
      "UNCATEGORIZED": "Necategorizat",
      "SEARCH_RESULTS": "Rezultate căutare pentru {query}",
      "EMPTY_TEXT": "Căutați articole pentru a le insera în răspunsuri.",
      "SEARCH_LOADER": "In căutare...",
      "INSERT_ARTICLE": "Inserați",
      "NO_RESULT": "Nu s-au găsit articole",
      "COPY_LINK": "Copiați link-ul articolului în clipboard",
      "OPEN_LINK": "Deschide articolul în tab nou",
      "PREVIEW_LINK": "Previzualizează articolul"
    },
    "PORTAL": {
      "HEADER": "Portaluri",
      "DEFAULT": "Implicit",
      "NEW_BUTTON": "Portal nou",
      "ACTIVE_BADGE": "activ",
      "CHOOSE_LOCALE_LABEL": "Alegeți o limbă",
      "LOADING_MESSAGE": "Se încarcă portalurile...",
      "ARTICLES_LABEL": "articole",
      "NO_PORTALS_MESSAGE": "Nu există portaluri disponibile",
      "ADD_NEW_LOCALE": "Adaugați o nouă limba",
      "POPOVER": {
        "TITLE": "Portaluri",
        "PORTAL_SETTINGS": "Setări portal",
        "SUBTITLE": "Aveți mai multe portaluri și puteți avea limbi diferite pentru fiecare portal.",
        "CANCEL_BUTTON_LABEL": "Renunță",
        "CHOOSE_LOCALE_BUTTON": "Alegeți limba"
      },
      "PORTAL_SETTINGS": {
        "LIST_ITEM": {
          "HEADER": {
            "COUNT_LABEL": "articole",
            "ADD": "Adaugă limba",
            "VISIT": "Vizitați site-ul",
            "SETTINGS": "Setări",
            "DELETE": "Şterge"
          },
          "PORTAL_CONFIG": {
            "TITLE": "Configurații portal",
            "ITEMS": {
              "NAME": "Nume",
              "DOMAIN": "Domeniu personalizat",
              "SLUG": "Slug",
              "TITLE": "Titlu portal",
              "THEME": "Culoare temă",
              "SUB_TEXT": "Subtext portal"
            }
          },
          "AVAILABLE_LOCALES": {
            "TITLE": "Limbi disponibile",
            "TABLE": {
              "NAME": "Nume limbă",
              "CODE": "Cod limbă",
              "ARTICLE_COUNT": "Nr. articole",
              "CATEGORIES": "Nr. categorii",
              "SWAP": "Schimbă",
              "DELETE": "Şterge",
              "DEFAULT_LOCALE": "Implicit"
            }
          }
        },
        "DELETE_PORTAL": {
          "TITLE": "Ştergeţi portalul",
          "MESSAGE": "Sigur doriți să ștergeți acest portal",
          "YES": "Da, șterge portalul",
          "NO": "Nu, păstrează portalul",
          "API": {
            "DELETE_SUCCESS": "Portalul a fost sters",
            "DELETE_ERROR": "Eroare la ștergerea portalului"
          }
        }
      },
      "EDIT": {
        "HEADER_TEXT": "Editare portal",
        "TABS": {
          "BASIC_SETTINGS": {
            "TITLE": "Informaţii de bază"
          },
          "CUSTOMIZATION_SETTINGS": {
            "TITLE": "Personalizare portal"
          },
          "CATEGORY_SETTINGS": {
            "TITLE": "Categorii"
          },
          "LOCALE_SETTINGS": {
            "TITLE": "Limbi"
          }
        },
        "CATEGORIES": {
          "TITLE": "Categorii în",
          "NEW_CATEGORY": "Categorie nouă",
          "TABLE": {
            "NAME": "Nume",
            "DESCRIPTION": "Descriere",
            "LOCALE": "Limbă",
            "ARTICLE_COUNT": "Nr. articole",
            "ACTION_BUTTON": {
              "EDIT": "Editare categorie",
              "DELETE": "Ștergere categorie"
            },
            "EMPTY_TEXT": "Nu au fost găsite categorii"
          }
        },
        "EDIT_BASIC_INFO": {
          "BUTTON_TEXT": "Actualizați setările de bază"
        }
      },
      "ADD": {
        "CREATE_FLOW": {
          "BASIC": {
            "TITLE": "Informații centru de asistență",
            "BODY": "Informații de bază despre portal"
          },
          "CUSTOMIZATION": {
            "TITLE": "Personalizare centru de asistență",
            "BODY": "Personalizați portalul"
          },
          "FINISH": {
            "TITLE": "Voila! 🎉",
            "BODY": "Totul este pregătit!"
          }
        },
        "CREATE_FLOW_PAGE": {
          "BACK_BUTTON": "Înapoi",
          "BASIC_SETTINGS_PAGE": {
            "HEADER": "Creează Portal",
            "TITLE": "Informații centru de asistență",
            "CREATE_BASIC_SETTING_BUTTON": "Creează setări de bază portal"
          },
          "CUSTOMIZATION_PAGE": {
            "HEADER": "Personalizare portal",
            "TITLE": "Personalizare centru de asistență",
            "UPDATE_PORTAL_BUTTON": "Actualizați setările portalului"
          },
          "FINISH_PAGE": {
            "TITLE": "Voila!🎉 Totul este pregătit!",
            "MESSAGE": "Puteți vedea acum acest portal creat pe pagina de portaluri.",
            "FINISH": "Mergeți la toate pagina portalurilor"
          }
        },
        "LOGO": {
          "LABEL": "Logo",
          "UPLOAD_BUTTON": "Încărcaţi logo",
          "HELP_TEXT": "Acest logo va fi afișat in antetul portalului.",
          "IMAGE_UPLOAD_SUCCESS": "Logo încărcat cu succes",
          "IMAGE_UPLOAD_ERROR": "Logo șters cu succes",
          "IMAGE_DELETE_ERROR": "Eroare la ștergerea logo-ului"
        },
        "NAME": {
          "LABEL": "Nume",
          "PLACEHOLDER": "Nume portal",
          "HELP_TEXT": "Denumirea va fi utilizată la nivel intern în portalul public.",
          "ERROR": "Numele este obligatoriu"
        },
        "SLUG": {
          "LABEL": "Slug",
          "PLACEHOLDER": "Slug-ul portalului pentru url-uri",
          "ERROR": "Slug-ul este necesar"
        },
        "DOMAIN": {
          "LABEL": "Domeniu personalizat",
          "PLACEHOLDER": "Domeniu personalizat portal",
          "HELP_TEXT": "Adăugați doar dacă doriți să utilizați un domeniu personalizat pentru portalurile dvs. Ex: {exampleURL}",
          "ERROR": "Introduceți o adresă URL validă"
        },
        "HOME_PAGE_LINK": {
          "LABEL": "Link pagină de pornire",
          "PLACEHOLDER": "Link pagină portal",
          "HELP_TEXT": "Linkul folosit pentru a reveni din portal la pagina principală. Ex: {exampleURL}",
          "ERROR": "Introduceți un URL valid pentru pagina principală"
        },
        "THEME_COLOR": {
          "LABEL": "Culoare temă portal",
          "HELP_TEXT": "Această culoare va fi afișată ca culoare temă pentru portal."
        },
        "PAGE_TITLE": {
          "LABEL": "Titlu pagină",
          "PLACEHOLDER": "Titlu pagină portal",
          "HELP_TEXT": "Titlul paginii va fi utilizat în portalul destinat publicului.",
          "ERROR": "Titlul paginii este obligatoriu"
        },
        "HEADER_TEXT": {
          "LABEL": "Text antet",
          "PLACEHOLDER": "Text antet portal",
          "HELP_TEXT": "Textul din antetul portalului va fi utilizat în portalul public.",
          "ERROR": "Textul antetului portalului este obligatoriu"
        },
        "API": {
          "SUCCESS_MESSAGE_FOR_BASIC": "Portalul a fost creat.",
          "ERROR_MESSAGE_FOR_BASIC": "Portalul nu a putut fi creat. Încercați din nou.",
          "SUCCESS_MESSAGE_FOR_UPDATE": "Portalul a fost actualizat.",
          "ERROR_MESSAGE_FOR_UPDATE": "Portalul nu a putut fi actualizat. Încercați din nou."
        }
      },
      "ADD_LOCALE": {
        "TITLE": "Adaugați o nouă limba",
        "SUB_TITLE": "Aceasta adaugă o nouă limbă în lista dvs de traduceri disponibile.",
        "PORTAL": "Portal",
        "LOCALE": {
          "LABEL": "Limbă",
          "PLACEHOLDER": "Alegeți o limbă",
          "ERROR": "Limba este obligatorie"
        },
        "BUTTONS": {
          "CREATE": "Creează limba",
          "CANCEL": "Renunță"
        },
        "API": {
          "SUCCESS_MESSAGE": "Limbă adăugata cu succes",
          "ERROR_MESSAGE": "Nu se poate adăuga limba. Încercați din nou."
        }
      },
      "CHANGE_DEFAULT_LOCALE": {
        "API": {
          "SUCCESS_MESSAGE": "Limba implicită a fost actualizată",
          "ERROR_MESSAGE": "Nu se poate actualiza limba implicită. Încercați din nou."
        }
      },
      "DELETE_LOCALE": {
        "API": {
          "SUCCESS_MESSAGE": "Limbă ștearsă din portal cu succes",
          "ERROR_MESSAGE": "Nu s-a putut elimina limba din portal. Încercați din nou."
        }
      }
    },
    "TABLE": {
      "404": "Nici un articol nu corespunde căutării tale 🔍",
      "LOADING_MESSAGE": "Se încarcă articolele...",
      "NO_ARTICLES": "Nu există articole disponibile",
      "HEADERS": {
        "TITLE": "Titlu",
        "CATEGORY": "Categorie",
        "READ_COUNT": "Vizualizări",
        "STATUS": "Stare",
        "LAST_EDITED": "Ultima modificare"
      },
      "COLUMNS": {
        "BY": "de",
        "AUTHOR_NOT_AVAILABLE": "Autorul nu este disponibil"
      }
    },
    "EDIT_ARTICLE": {
      "LOADING": "Se încarcă articolul...",
      "TITLE_PLACEHOLDER": "Titlul articolului este introdus aici",
      "CONTENT_PLACEHOLDER": "Scrieți articolul aici",
      "API": {
        "ERROR": "Eroare la salvarea articolului"
      }
    },
    "PUBLISH_ARTICLE": {
      "API": {
        "ERROR": "Eroare la publicarea articolului",
        "SUCCESS": "Articolul a fost publicat"
      }
    },
    "ARCHIVE_ARTICLE": {
      "API": {
        "ERROR": "Eroare la arhivarea articolului",
        "SUCCESS": "Articolul a fost arhivat"
      }
    },
    "DRAFT_ARTICLE": {
      "API": {
        "ERROR": "Eroare la salvarea articolului ca ciornă",
        "SUCCESS": "Articolul a fost salvat ca ciornă"
      }
    },
    "DELETE_ARTICLE": {
      "MODAL": {
        "CONFIRM": {
          "TITLE": "Confirmă ștergerea",
          "MESSAGE": "Sigur doriți să ștergeți articolul?",
          "YES": "Da, șterge",
          "NO": "Nu, păstreaza"
        }
      },
      "API": {
        "SUCCESS_MESSAGE": "Articolul a fost şters",
        "ERROR_MESSAGE": "Eroare la ștergerea articolului"
      }
    },
    "CREATE_ARTICLE": {
      "ERROR_MESSAGE": "Vă rugăm să adăugați titlul articolului și conținutul pentru a putea actualiza setările"
    },
    "SIDEBAR": {
      "SEARCH": {
        "PLACEHOLDER": "Căutați articole"
      }
    },
    "CATEGORY": {
      "ADD": {
        "TITLE": "Creați o categorie",
        "SUB_TITLE": "Categoria va fi folosită în portalul public pentru a clasifica articolele.",
        "PORTAL": "Portal",
        "LOCALE": "Limbă",
        "NAME": {
          "LABEL": "Nume",
          "PLACEHOLDER": "Nume categorie",
          "HELP_TEXT": "Numele și pictograma categoriei vor fi utilizate în portalul public pentru a clasifica articolele.",
          "ERROR": "Numele este obligatoriu"
        },
        "SLUG": {
          "LABEL": "Slug",
          "PLACEHOLDER": "Slug-ul categoriei pentru url-uri",
          "HELP_TEXT": "chat.jarabot.com/hc/my-portal/en-US/categories/my-slug",
          "ERROR": "Slug-ul este obligatoriu"
        },
        "DESCRIPTION": {
          "LABEL": "Descriere",
          "PLACEHOLDER": "Oferiți o scurtă descriere pentru categorie.",
          "ERROR": "Descrierea este obligatorie"
        },
        "BUTTONS": {
          "CREATE": "Creați categoria",
          "CANCEL": "Renunță"
        },
        "API": {
          "SUCCESS_MESSAGE": "Categoria a fost creată",
          "ERROR_MESSAGE": "Nu s-a putut crea categoria"
        }
      },
      "EDIT": {
        "TITLE": "Editați o categorie",
        "SUB_TITLE": "Editarea unei categorii va actualiza categoria în portalul public.",
        "PORTAL": "Portal",
        "LOCALE": "Limbă",
        "NAME": {
          "LABEL": "Nume",
          "PLACEHOLDER": "Nume categorie",
          "HELP_TEXT": "Numele și pictograma categoriei vor fi utilizate în portalul public pentru a clasifica articolele.",
          "ERROR": "Numele este obligatoriu"
        },
        "SLUG": {
          "LABEL": "Slug",
          "PLACEHOLDER": "Slug-ul categoriei pentru url-uri",
          "HELP_TEXT": "chat.jarabot.com/hc/my-portal/en-US/categories/my-slug",
          "ERROR": "Slug-ul este obligatoriu"
        },
        "DESCRIPTION": {
          "LABEL": "Descriere",
          "PLACEHOLDER": "Oferiți o scurtă descriere pentru categorie.",
          "ERROR": "Descrierea este obligatorie"
        },
        "BUTTONS": {
          "CREATE": "Actualizați categoria",
          "CANCEL": "Renunță"
        },
        "API": {
          "SUCCESS_MESSAGE": "Categoria a fost actualizată",
          "ERROR_MESSAGE": "Nu s-a putut actualiza categoria"
        }
      },
      "DELETE": {
        "API": {
          "SUCCESS_MESSAGE": "Categoria a fost ștearsă",
          "ERROR_MESSAGE": "Nu s-a putut șterge categoria"
        }
      }
    },
    "ARTICLE_SEARCH": {
      "TITLE": "Căutare articole",
      "PLACEHOLDER": "Căutare articole",
      "NO_RESULT": "Nu s-au găsit articole",
      "SEARCHING": "In căutare...",
      "SEARCH_BUTTON": "Caută",
      "INSERT_ARTICLE": "Inserează link",
      "IFRAME_ERROR": "URL-ul este gol sau invalid. Conținutul nu poate fi afișat.",
      "OPEN_ARTICLE_SEARCH": "Inserează articol din Centrul de asistență",
      "SUCCESS_ARTICLE_INSERTED": "Articolul a fost inserat cu succes",
      "PREVIEW_LINK": "Previzualizează articolul",
      "CANCEL": "Închide",
      "BACK": "Înapoi",
      "BACK_RESULTS": "Înapoi la rezultate"
    },
    "UPGRADE_PAGE": {
      "TITLE": "Asistenta",
      "DESCRIPTION": "Creați portaluri de autoservire ușor de utilizat. Ajutați-vă utilizatorii să acceseze articolele și să primească asistență 24/7. Faceți upgrade abonamentului pentru a activa această funcție.",
      "SELF_HOSTED_DESCRIPTION": "Creați portaluri de autoservire ușor de utilizat. Ajutați-vă utilizatorii să acceseze articolele și să primească asistență 24/7. Contactați administratorul pentru a activa această funcție.",
      "BUTTON": {
        "LEARN_MORE": "Află mai mult",
        "UPGRADE": "Actualizare"
      },
      "FEATURES": {
        "PORTALS": {
          "TITLE": "Portaluri multiple",
          "DESCRIPTION": "Creați mai multe portaluri de asistență pentru produse diferite folosind același cont."
        },
        "LOCALES": {
          "TITLE": "Suport complet pentru limbi",
          "DESCRIPTION": "Localizați portalul în limba dvs. Susținem toate limbile și permitem traduceri pentru fiecare articol."
        },
        "SEO": {
          "TITLE": "Design optimizat pentru SEO",
          "DESCRIPTION": "Personalizați etichetele meta pentru a vă îmbunătăți vizibilitatea pe motoarele de căutare cu paginile noastre optimizate pentru SEO."
        },
        "API": {
          "TITLE": "Suport API complet",
          "DESCRIPTION": "Folosiți portalul ca CMS headless cu framework-uri front-end terțe, utilizând API-urile noastre."
        }
      }
    },
    "LOADING": "Se încarcă...",
    "ARTICLES_PAGE": {
      "ARTICLE_CARD": {
        "CARD": {
          "VIEWS": "{count} vizualizare | {count} vizualizări",
          "DROPDOWN_MENU": {
            "PUBLISH": "Publicați",
            "DRAFT": "Draft",
            "ARCHIVE": "Arhivează",
            "DELETE": "Şterge"
          },
          "STATUS": {
            "DRAFT": "Draft",
            "PUBLISHED": "Publicat",
            "ARCHIVED": "Arhivat"
          },
          "CATEGORY": {
            "UNCATEGORISED": "Necategorizat"
          }
        }
      },
      "ARTICLES_HEADER": {
        "TABS": {
          "ALL": "Toate articolele",
          "MINE": "Ale mele",
          "DRAFT": "Draft",
          "PUBLISHED": "Publicat",
          "ARCHIVED": "Arhivat"
        },
        "CATEGORY": {
          "ALL": "Toate categoriile"
        },
        "LOCALE": {
          "ALL": "Toate limbile"
        },
        "NEW_ARTICLE": "Articol nou"
      },
      "EMPTY_STATE": {
        "ALL": {
          "TITLE": "Scrieți un articol",
          "SUBTITLE": "Scrieți un articol elaborat, hai să începem!",
          "BUTTON_LABEL": "Articol nou"
        },
        "MINE": {
          "TITLE": "Nu ați scris încă niciun articol aici",
          "SUBTITLE": "Toate articolele scrise de dvs. apar aici pentru acces rapid."
        },
        "DRAFT": {
          "TITLE": "Nu există articole în Draft",
          "SUBTITLE": "Articolele Draft vor apărea aici"
        },
        "PUBLISHED": {
          "TITLE": "Nu există articole publicate",
          "SUBTITLE": "Articolele publicate vor apărea aici"
        },
        "ARCHIVED": {
          "TITLE": "Nu există articole în arhivă",
          "SUBTITLE": "Articolele arhivate nu apar pe portal, le puteți folosi pentru a marca pagini depreciate sau învechite"
        },
        "CATEGORY": {
          "TITLE": "Nu există articole în această categorie",
          "SUBTITLE": "Articolele din această categorie vor apărea aici"
        }
      }
    },
    "CATEGORY_PAGE": {
      "CATEGORY_HEADER": {
        "NEW_CATEGORY": "Categorie nouă",
        "EDIT_CATEGORY": "Editare categorie",
        "CATEGORIES_COUNT": "{n} categorie | {n} categorii",
        "BREADCRUMB": {
          "CATEGORY_LOCALE": "Categorii ({localeCode})",
          "ACTIVE_CATEGORY": "{categoryName} ({categoryCount} articole) | {categoryName} ({categoryCount} articol)"
        }
      },
      "CATEGORY_EMPTY_STATE": {
        "TITLE": "Nu au fost găsite categorii",
        "SUBTITLE": "Categoriile vor apărea aici. Puteți adăuga o categorie apăsând butonul „Categorie nouă”."
      },
      "CATEGORY_CARD": {
        "ARTICLES_COUNT": "{count} articol | {count} articole",
        "EXPAND": "Afișează subcategoriile",
        "COLLAPSE": "Ascunde subcategoriile",
        "MENU": {
          "NEW_ARTICLE": "Articol nou",
          "ADD_SUBCATEGORY": "Adaugă subcategorie",
          "EDIT": "Editează",
          "DELETE": "Șterge"
        }
      },
      "CATEGORY_DIALOG": {
        "CREATE": {
          "API": {
            "SUCCESS_MESSAGE": "Categoria a fost creată",
            "ERROR_MESSAGE": "Nu s-a putut crea categoria"
          }
        },
        "EDIT": {
          "API": {
            "SUCCESS_MESSAGE": "Categoria a fost actualizată",
            "ERROR_MESSAGE": "Nu s-a putut actualiza categoria"
          }
        },
        "DELETE": {
          "API": {
            "SUCCESS_MESSAGE": "Categoria a fost ștearsă",
            "ERROR_MESSAGE": "Nu s-a putut șterge categoria"
          },
          "CONFIRM": {
            "TITLE": "Șterge categoria",
            "DESCRIPTION": "Sigur doriți să ștergeți această categorie? Articolele sale vor deveni necategorizate.",
            "DESCRIPTION_WITH_CHILDREN": "Sigur doriți să ștergeți această categorie? Articolele sale vor deveni necategorizate, iar {count} subcategorie va fi mutată la nivelul superior. | Sigur doriți să ștergeți această categorie? Articolele sale vor deveni necategorizate, iar {count} subcategorii vor fi mutate la nivelul superior.",
            "CONFIRM": "Șterge"
          }
        },
        "HEADER": {
          "CREATE": "Creați categoria",
          "EDIT": "Editare categorie",
          "DESCRIPTION": "Editarea unei categorii va actualiza categoria în portalul public.",
          "PORTAL": "Portal",
          "LOCALE": "Limbă"
        },
        "FORM": {
          "NAME": {
            "LABEL": "Nume",
            "PLACEHOLDER": "Nume categorie",
            "ERROR": "Numele este obligatoriu"
          },
          "SLUG": {
            "LABEL": "Slug",
            "PLACEHOLDER": "Slug-ul categoriei pentru url-uri",
            "ERROR": "Slug-ul este obligatoriu",
            "HELP_TEXT": "chat.jarabot.com/hc/{portalSlug}/{localeCode}/categories/{categorySlug}"
          },
          "DESCRIPTION": {
            "LABEL": "Descriere",
            "PLACEHOLDER": "Oferiți o scurtă descriere pentru categorie.",
            "ERROR": "Descrierea este obligatorie"
          },
          "PARENT_CATEGORY": {
            "LABEL": "Categorie părinte",
            "PLACEHOLDER": "Selectați o categorie părinte",
            "NONE": "Niciuna (nivel superior)"
          }
        },
        "BUTTONS": {
          "CREATE": "Creeaza",
          "EDIT": "Actualizare",
          "CANCEL": "Renunță"
        }
      }
    },
    "LOCALES_PAGE": {
      "LOCALES_COUNT": "Nicio limbă disponibilă | {n} limbă | {n} limbi",
      "NEW_LOCALE_BUTTON_TEXT": "Limbă nouă",
      "LOCALE_CARD": {
        "ARTICLES_COUNT": "{count} articol | {count} articole",
        "CATEGORIES_COUNT": "{count} categorie | {count} categorii",
        "DEFAULT": "Implicit",
        "DROPDOWN_MENU": {
          "MAKE_DEFAULT": "Setează ca implicit",
          "DELETE": "Şterge"
        }
      },
      "ADD_LOCALE_DIALOG": {
        "TITLE": "Adaugați o nouă limba",
        "DESCRIPTION": "Selectați limba în care va fi scris acest articol. Aceasta va fi adăugată la lista dvs. de traduceri, iar mai târziu puteți adăuga altele.",
        "COMBOBOX": {
          "PLACEHOLDER": "Selectați limba..."
        },
        "API": {
          "SUCCESS_MESSAGE": "Limbă adăugata cu succes",
          "ERROR_MESSAGE": "Nu se poate adăuga limba. Încercați din nou."
        }
      }
    },
    "EDIT_ARTICLE_PAGE": {
      "HEADER": {
        "STATUS": {
          "SAVING": "Se salvează...",
          "SAVED": "Salvat"
        },
        "PREVIEW": "Previzualizați",
        "PUBLISH": "Publicați",
        "DRAFT": "Draft",
        "ARCHIVE": "Arhivează",
        "BACK_TO_ARTICLES": "Înapoi la articole"
      },
      "DRAFT": {
        "PENDING_LABEL": "Modificări nepublicate",
        "PROMOTE": "Publică modificările",
        "DISCARD": "Renunță la modificări",
        "PROMOTE_SUCCESS": "Modificările ciornei au fost publicate în articol",
        "PROMOTE_ERROR": "Modificările ciornei nu au putut fi publicate",
        "DISCARD_SUCCESS": "Modificările ciornei au fost eliminate",
        "DISCARD_ERROR": "Modificările ciornei nu au putut fi eliminate"
      },
      "VERSION_HISTORY": {
        "MENU_ITEM": "Istoricul versiunilor",
        "TITLE": "Istoricul versiunilor",
        "BACK": "Înapoi la articol",
        "LOADING": "Se încarcă versiunile...",
        "EMPTY": "Nu există încă versiuni. Modificările aduse acestui articol vor apărea aici.",
        "EMPTY_CONTENT": "Această versiune nu are conținut.",
        "CURRENT_BADGE": "Curentă",
        "RESTORED_BADGE": "Restaurată",
        "AUTOMATED_USER": "Actualizare automată",
        "RESTORE": "Restaurează această versiune",
        "RESTORE_DIALOG": {
          "TITLE": "Restaurezi această versiune?",
          "DESCRIPTION": "Articolul va reveni la formularea acestei versiuni. Nimic nu se pierde — textul curent rămâne în istoric, iar un articol publicat continuă să afișeze versiunea live până publici modificarea.",
          "CONFIRM": "Restaurează"
        },
        "RESTORE_SUCCESS": "Versiunea a fost restaurată",
        "RESTORE_ERROR": "Versiunea nu a putut fi restaurată",
        "FETCH_ERROR": "Istoricul versiunilor nu a putut fi încărcat"
      },
      "EDIT_ARTICLE": {
        "MORE_PROPERTIES": "Mai multe proprietăți",
        "TRANSLATE": "Tradu",
        "SOURCE": "Markdown",
        "UNCATEGORIZED": "Necategorizat",
        "EDITOR_PLACEHOLDER": "Scrieți ceva...",
        "HTML_EMBED": {
          "TITLE": "Inserează HTML personalizat",
          "DESCRIPTION": "Lipește cod HTML brut, cum ar fi un iframe, un embed sau un fragment de widget. Va fi afișat ca atare în articolul publicat.",
          "PLACEHOLDER": "<iframe src=\"https://...\"></iframe>",
          "INSERT": "Inserează"
        },
        "PRIMARY_CATEGORY": "Categorie principală"
      },
      "ARTICLE_PROPERTIES": {
        "ARTICLE_PROPERTIES": "Proprietăți articol",
        "SLUG": "Slug",
        "EDIT_SLUG": "Edit slug",
        "META_DESCRIPTION": "Descriere meta",
        "META_DESCRIPTION_PLACEHOLDER": "Adaugă descriere meta",
        "META_TITLE": "Titlu meta",
        "META_TITLE_PLACEHOLDER": "Adaugă titlu meta",
        "META_TAGS": "Etichete meta",
        "META_TAGS_PLACEHOLDER": "Adaugă etichete meta",
        "SET_AS_HOMEPAGE": "Set as homepage",
        "SET_AS_HOMEPAGE_HELP": "Show this article as the help center homepage for this language. Add {'{{NAV}}'} in the content to include search + categories.",
        "LANGUAGE_MUTATIONS": "Variante de limbă",
        "LANGUAGE_MUTATIONS_EMPTY": "Niciun articol asociat încă",
        "ADD_MUTATION": "Adaugă",
        "REMOVE_MUTATION": "Elimină"
      },
      "LANGUAGE_MUTATIONS_DIALOG": {
        "TITLE": "Asociază variante de limbă",
        "SEARCH_PLACEHOLDER": "Caută articole după titlu",
        "EMPTY": "Niciun articol potrivit",
        "CANCEL": "Anulează",
        "ADD_SELECTED": "Adaugă selecția",
        "SUCCESS": "Variante actualizate",
        "ERROR": "Actualizarea variantelor a eșuat"
      },
      "TRANSLATE_DIALOG": {
        "TITLE": "Tradu articolul",
        "DESCRIPTION": "Selectează limbile în care vrei să traduci acest articol. Limbile deja traduse vor fi retraduse într-un Draft pentru revizuire.",
        "EMPTY": "Nu există alte limbi disponibile.",
        "CONNECTED_BADGE": "Tradus",
        "CANCEL": "Anulează",
        "TRANSLATE": "Tradu",
        "SUCCESS": "Traducerea va începe în curând. Articolele traduse vor apărea în curând ca variante de limbă.",
        "ERROR": "Nu s-a putut începe traducerea"
      },
      "SLUG_DIALOG": {
        "TITLE": "Edit article URL",
        "DESCRIPTION": "Change the descriptive part of this article's slug. Old links keep working — they redirect here automatically.",
        "INPUT_LABEL": "Slug",
        "PLACEHOLDER": "getting-started",
        "PREFIX_HINT": "The numeric prefix is a permanent identifier and cannot be changed.",
        "PREVIEW": "Article URL",
        "CANCEL": "Cancel",
        "SAVE": "Save",
        "SUCCESS": "Article URL updated",
        "ERROR": "Failed to update the article URL"
      },
      "API": {
        "ERROR": "Eroare la salvarea articolului"
      }
    },
    "PORTAL_SWITCHER": {
      "NEW_PORTAL": "Portal nou",
      "PORTALS": "Portaluri",
      "CREATE_PORTAL": "Creați și gestionați mai multe portaluri",
      "ARTICLES": "articole",
      "DOMAIN": "domeniu",
      "PORTAL_NAME": "Nume portal"
    },
    "CREATE_PORTAL_DIALOG": {
      "TITLE": "Creează portal nou",
      "DESCRIPTION": "Dați un nume portalului dvs. și creați un slug URL ușor de utilizat. Puteți modifica ambele mai târziu din setări.",
      "CONFIRM_BUTTON_LABEL": "Creeaza",
      "NAME": {
        "LABEL": "Nume",
        "PLACEHOLDER": "Ghid utilizator",
        "MESSAGE": "Alegeți un nume pentru portalul dvs.",
        "ERROR": "Numele este obligatoriu"
      },
      "SLUG": {
        "LABEL": "Slug",
        "PLACEHOLDER": "user-guide",
        "ERROR": "Slug-ul este obligatoriu",
        "FORMAT_ERROR": "Folosiți doar litere, cifre și cratime, de exemplu: user-guide"
      }
    },
    "PORTAL_SETTINGS": {
      "FORM": {
        "AVATAR": {
          "LABEL": "Logo",
          "IMAGE_UPLOAD_ERROR": "Imaginea nu a putut fi încărcată! Încercați din nou",
          "IMAGE_UPLOAD_SUCCESS": "Imagine adăugată cu succes. Apăsați pe salvare modificări pentru a salva logo-ul",
          "IMAGE_DELETE_SUCCESS": "Logo șters cu succes",
          "IMAGE_DELETE_ERROR": "Nu s-a putut șterge logo-ul",
          "IMAGE_UPLOAD_SIZE_ERROR": "Dimensiunea imaginii trebuie să fie mai mică de {size}MB"
        },
        "HERO_IMAGE": {
          "LABEL": "Hero image",
          "HELP_TEXT": "Optional full-width background image shown behind the centered search box on the help center homepage.",
          "IMAGE_UPLOAD_ERROR": "Couldn't upload image! Try again",
          "IMAGE_UPLOAD_SUCCESS": "Image added successfully. Please click on save changes to save the hero image",
          "IMAGE_DELETE_SUCCESS": "Hero image deleted successfully",
          "IMAGE_DELETE_ERROR": "Unable to delete hero image",
          "IMAGE_UPLOAD_SIZE_ERROR": "Image size should be less than {size}MB"
        },
        "HOMEPAGE_ARTICLES": {
          "LABEL": "Homepage articles",
          "EMPTY": "No article is set as the homepage. Set one from an article's properties.",
          "HELP_TEXT": "The article shown as the homepage for each language. Click to open it, or remove to restore the default homepage.",
          "REMOVE": "Remove",
          "REMOVE_SUCCESS": "Homepage article removed",
          "REMOVE_ERROR": "Unable to remove homepage article"
        },
        "NAME": {
          "LABEL": "Nume",
          "PLACEHOLDER": "Nume portal",
          "ERROR": "Numele este obligatoriu"
        },
        "HEADER_TEXT": {
          "LABEL": "Text antet",
          "PLACEHOLDER": "Text antet portal"
        },
        "PAGE_TITLE": {
          "LABEL": "Titlu pagină",
          "PLACEHOLDER": "Titlu pagină portal"
        },
        "HOME_PAGE_LINK": {
          "LABEL": "Link pagină de pornire",
          "PLACEHOLDER": "Link pagină portal",
          "ERROR": "URL invalid. Linkul paginii de pornire trebuie să înceapă cu 'http://' sau 'https://'."
        },
        "SLUG": {
          "LABEL": "Slug",
          "PLACEHOLDER": "Slug portal"
        },
        "LIVE_CHAT_WIDGET": {
          "LABEL": "Widget chat live",
          "PLACEHOLDER": "Selectați widgetul de chat live",
          "HELP_TEXT": "Selectați un widget de chat live care va apărea pe centrul dvs. de asistență"
        },
        "PUBLIC_ACCESS": {
          "LABEL": "Acces public",
          "HELP_TEXT": "Faceți portalul accesibil oricui deține link-ul.",
          "OPTIONS": {
            "PUBLIC": "Da",
            "PRIVATE": "Nu"
          }
        },
        "LINK_TARGET": {
          "LABEL": "Destinația linkului",
          "HELP_TEXT": "Alegeți dacă linkurile din articole se deschid în fereastra curentă sau într-una nouă.",
          "OPTIONS": {
            "CURRENT_WINDOW": "Fereastra curentă",
            "NEW_WINDOW": "Fereastră nouă"
          }
        },
        "DEFAULT_IMAGE_SIZE": {
          "LABEL": "Dimensiune implicită a imaginii",
          "HELP_TEXT": "Dimensiunea aplicată fiecărei imagini pe care o inserați într-un articol. Alegeți „Original” pentru a insera imaginile la dimensiunea proprie și alegeți în schimb o dimensiune pentru fiecare imagine."
        },
        "BRAND_COLOR": {
          "LABEL": "Culoare brand"
        },
        "CUSTOM_HTML": {
          "LABEL": "HTML personalizat",
          "PLACEHOLDER": "<!-- Inserați aici fragmentul de cod pentru analiză sau urmărire -->",
          "HELP_TEXT": "Inserat la începutul etichetei <body> pe fiecare pagină a centrului de asistență. Utilizați-l pentru Google Analytics, Google Tag Manager sau orice alt fragment de cod de urmărire. Codul este afișat exact așa cum a fost introdus și nu este validat."
        },
        "SAVE_CHANGES": "Salvează modificările"
      },
      "CONFIGURATION_FORM": {
        "CUSTOM_DOMAIN": {
          "HEADER": "Domeniu personalizat",
          "LABEL": "Domeniu personalizat:",
          "DESCRIPTION": "Puteți găzdui portalul pe un domeniu personalizat. De exemplu, dacă site-ul dvs. este yourdomain.com și doriți ca portalul să fie disponibil la docs.yourdomain.com, introduceți acest lucru în acest câmp.",
          "PLACEHOLDER": "Domeniu personalizat portal",
          "EDIT_BUTTON": "Editează domeniul personalizat",
          "ADD_BUTTON": "Adaugă domeniu personalizat",
          "DIALOG": {
            "ADD_HEADER": "Adaugă domeniu personalizat",
            "EDIT_HEADER": "Editează domeniul personalizat",
            "ADD_CONFIRM_BUTTON_LABEL": "Adaugă domeniu",
            "EDIT_CONFIRM_BUTTON_LABEL": "Actualizează domeniul",
            "LABEL": "Domeniu personalizat",
            "PLACEHOLDER": "Domeniu personalizat portal",
            "ERROR": "Domeniul personalizat este obligatoriu"
          },
          "DNS_CONFIGURATION_DIALOG": {
            "HEADER": "Configurare DNS",
            "DESCRIPTION": "Conectați-vă la contul dvs. de la furnizorul DNS și adăugați înregistrarea CNAME de mai jos pentru subdomeniul dvs.",
            "HELP_TEXT": "După ce ați terminat, puteți contacta echipa noastră de asistență pentru a solicita certificatul SSL generat automat.",
            "CONFIRM_BUTTON_LABEL": "Am înțeles!"
          }
        },
        "DELETE_PORTAL": {
          "BUTTON": "Șterge {portalName}",
          "HEADER": "Ştergeţi portalul",
          "DESCRIPTION": "Ștergeți definitiv acest portal. Această acțiune este ireversibilă",
          "DIALOG": {
            "HEADER": "Sigur doriți să ștergeți {portalName}?",
            "DESCRIPTION": "Aceasta este o acțiune permanentă care nu poate fi anulată.",
            "CONFIRM_BUTTON_LABEL": "Şterge"
          }
        },
        "EDIT_CONFIGURATION": "Editează configurația"
      },
      "API": {
        "CREATE_PORTAL": {
          "SUCCESS_MESSAGE": "Portalul a fost creat",
          "ERROR_MESSAGE": "Nu s-a putut crea portalul"
        },
        "UPDATE_PORTAL": {
          "SUCCESS_MESSAGE": "Portalul a fost actualizat",
          "ERROR_MESSAGE": "Nu s-a putut actualiza portalul"
        }
      }
    },
    "ATTACHMENTS": {
      "TITLE": "Atașamente",
      "DRAFT_BADGE": "Draft",
      "ADD_BUTTON": "Adaugă fișier",
      "DROP_HERE": "Trageți și plasați fișierele aici",
      "COPY_LINK": "Copiază linkul",
      "LINK_COPIED": "Link copiat în clipboard",
      "COPY_FAILED": "Copierea linkului a eșuat",
      "DELETE": "Șterge",
      "CANCEL": "Anulează",
      "QUEUED": "În așteptare",
      "UPLOADING": "Se încarcă",
      "UPLOAD_FAILED": "Încărcarea fișierului a eșuat",
      "FILE_TOO_LARGE": "Fișierul depășește limita de 40 MB"
    },
    "DICTIONARY_PAGE": {
      "HEADER": {
        "TITLE": "Dicționar de traduceri",
        "DESCRIPTION": "Termenii definiți aici sunt adăugați în promptul de traducere AI, astfel încât să fie traduși mereu în același mod. Termenul cheie este scris în {locale}."
      },
      "NEW_TERM": "Termen nou",
      "EMPTY_STATE": {
        "TITLE": "Niciun termen în dicționar încă",
        "SUBTITLE": "Adăugați un termen și traducerea acestuia pentru fiecare limbă. Când un articol este tradus, acești termeni sunt respectați, astfel încât terminologia produsului dvs. să rămână consecventă."
      },
      "LIST": {
        "TERM": "Termen",
        "TRANSLATIONS": "Traduceri",
        "ACTIONS": "Acțiuni"
      },
      "DICTIONARY_DIALOG": {
        "HEADER": {
          "CREATE": "Adaugă termen",
          "EDIT": "Editare termen",
          "DESCRIPTION": "Termenul de mai jos este respectat în timpul traducerii AI a articolelor din centrul de asistență.",
          "PORTAL": "Portal",
          "PRIMARY_LANGUAGE": "Limba principală"
        },
        "FORM": {
          "TERM": {
            "LABEL": "Termen ({locale})",
            "PLACEHOLDER": "Inbox",
            "ERROR": "Termenul este obligatoriu"
          },
          "DESCRIPTION": {
            "LABEL": "Context / note (opțional)",
            "PLACEHOLDER": "Când și cum este folosit acest termen, pentru a ajuta traducătorul să elimine ambiguitățile."
          },
          "TRANSLATIONS": "Traduceri",
          "TRANSLATION_PLACEHOLDER": "Lăsați gol pentru a permite AI-ului să traducă liber",
          "AUTO_TRANSLATE": {
            "BUTTON": "Tradu automat tot",
            "CONFIRM": "Traduceți în {count} limbi cu AI?",
            "CONFIRM_BUTTON": "Tradu",
            "CANCEL": "Renunță",
            "SUCCESS": "Traduceri generate — verificați și salvați",
            "ERROR": "Nu s-a putut traduce automat, încercați din nou"
          }
        },
        "BUTTONS": {
          "CREATE": "Adaugă termen",
          "EDIT": "Salvează",
          "CANCEL": "Renunță"
        },
        "CREATE": {
          "API": {
            "SUCCESS_MESSAGE": "Termen adăugat cu succes",
            "ERROR_MESSAGE": "Termenul nu a putut fi adăugat, încercați din nou"
          }
        },
        "EDIT": {
          "API": {
            "SUCCESS_MESSAGE": "Termen actualizat cu succes",
            "ERROR_MESSAGE": "Termenul nu a putut fi actualizat, încercați din nou"
          }
        }
      },
      "DELETE": {
        "CONFIRM": {
          "TITLE": "Șterge termenul",
          "DESCRIPTION": "Sigur doriți să ștergeți acest termen? Nu va mai fi respectat în timpul traducerii.",
          "CONFIRM": "Șterge"
        },
        "API": {
          "SUCCESS_MESSAGE": "Termen șters cu succes",
          "ERROR_MESSAGE": "Termenul nu a putut fi șters, încercați din nou"
        }
      }
    }
  }
}
